import { UnsuccessfulReasonAction } from "@/actions/pages/clients/recruitment/unsuccessful-reasons";

export function UnsuccessfulReasonOptions(props)
{
  return (
            <div className='JobActionOptions Close'>
                {
                      Object.keys(props.options).map((key,index) => {    
                                                                          return(
                                                                                      <div key    =  {`EmailTemplate_${key}`} 
                                                                                      className   =  "JobsOptionKeys"
                                                                                      onClick     =  {(event) => {    
                                                                                                                        event.stopPropagation();
                                                                                                                        props.unsuccessfulReasonAction.performJobAction(key, {
                                                                                                                                id                        :  props.id,
                                                                                                                                reason_id                 :  props.reason_id,
                                                                                                                                unsuccessfulReasonAction  :  props.unsuccessfulReasonAction
                                                                                                                        });
                                                                                                                  }}> 
                                                                                              {props.options[key]['title']}
                                                                                      </div>
                                                                              )
                                                                      })
                  }
                
            </div>
         )
} 